import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/orders'

const findOne = (orderCod, queryParams = '', organization) => AxiosClient.get(
  `${resource}/${orderCod}?${queryParams}`, { headers: { organization } }
)

export {
  findOne
}
